var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.73,56.24l-2.96-2.96,16.27-16.27-16.27-16.27,2.96-2.96,16.27,16.27,16.27-16.27,2.96,2.96-16.27,16.27,16.27,16.27-2.96,2.96-16.27-16.27-16.27,16.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep52);
export default __webpack_public_path__ + "static/media/step-5-2.98f4abb6c461624dd85e262775af9b96.svg";
export { ForwardRef as ReactComponent };